<button [routerLink]="['/services']" class="btn btn-sm mb-3 goback">
  <i class="bi bi-arrow-left me-1"></i> Back to Service List
</button>

<div class="service-form content-info">
  <h3 class="title mb-4 border-bottom pb-2">
    {{
      viewOnly
        ? "View Service Details"
        : serviceId
        ? "Edit Service"
        : "Create New Service"
    }}
  </h3>

  <div class="row g-3 mb-3">
    <div class="col-md-4 col-sm-6">
      <label class="form-label">Service Name</label>
      <input
        class="form-control"
        [(ngModel)]="servicePayload.name"
        placeholder="e.g., Routine Blood Panel"
        [readonly]="viewOnly"
      />
    </div>

    <!-- ✅ NEW FIELD: Service Owner -->
    <div class="col-md-2 col-sm-6">
      <label class="form-label">Service Owner</label>
      <input
        type="text"
        class="form-control"
        [(ngModel)]="servicePayload.serviceOwner"
        placeholder="e.g., Dr. Anita Sharma"
        [readonly]="viewOnly"
      />
    </div>
    <!-- ✅ END NEW FIELD -->

    <div class="col-md-2 col-sm-6">
      <label class="form-label">Department</label>
      <select
        class="form-control"
        [(ngModel)]="servicePayload.departmentId"
        [disabled]="viewOnly"
      >
        <option [ngValue]="null" disabled>-- Select Department --</option>
        @for (dept of departments; track dept) {
        <option [ngValue]="dept.id">{{ dept.name }}</option>
        }
      </select>
    </div>

    <div class="col-md-2 col-sm-6">
      <label class="form-label">SAC Code</label>
      <input
        class="form-control"
        [(ngModel)]="servicePayload.hsnCode"
        placeholder="e.g., 998311"
        [readonly]="viewOnly"
      />
    </div>

    <div class="col-md-2 col-sm-6">
      <label class="form-label">GST Slab</label>
      @if (viewOnly) {
      <p class="form-control-plaintext">
        {{ servicePayload.gstRate ? servicePayload.gstRate + "%" : "N/A" }}
      </p>
      } @if (!viewOnly) {
      <select
        class="form-control"
        [(ngModel)]="servicePayload.gstRate"
        [disabled]="viewOnly"
      >
        <option [ngValue]="null" disabled>-- Select GST Slab --</option>
        @for (slab of gstSlabs; track slab) {
        <option [ngValue]="slab.value">{{ slab.displayLabel }}</option>
        }
      </select>
      }
    </div>
  </div>

  <div class="row g-3">
    <div class="col-md-2 col-sm-6">
      <label class="form-label">Price</label>
      <div class="input-group">
        <span class="input-group-text">₹</span>
        <input
          type="number"
          class="form-control"
          [(ngModel)]="servicePayload.price"
          placeholder="0.00"
          [readonly]="viewOnly"
        />
      </div>
    </div>

    <div class="col-md-2 col-sm-6">
      <label class="form-label">Status</label>
      <div class="form-check form-switch mt-2">
        <input
          class="form-check-input"
          type="checkbox"
          id="isActiveSwitch"
          [(ngModel)]="servicePayload.isActive"
          [disabled]="viewOnly"
          role="switch"
        />
        <label class="form-check-label fw-bold" for="isActiveSwitch">
          <span
            [ngClass]="{
              'text-success': servicePayload.isActive,
              'text-danger': !servicePayload.isActive
            }"
          >
            {{ servicePayload.isActive ? "Active" : "Inactive" }}
          </span>
        </label>
      </div>
    </div>
  </div>

  <div class="row mb-4 mt-4">
    <div class="col-12">
      <label class="form-label">Description</label>
      <textarea
        class="form-control"
        rows="3"
        [(ngModel)]="servicePayload.description"
        placeholder="Detailed description of the service"
        [readonly]="viewOnly"
      ></textarea>
    </div>
  </div>

  <div class="row mt-4 pt-3 border-top">
    <div class="col-12 text-end">
      @if (!viewOnly) {
      <button
        class="btn btn-outline-secondary me-2"
        [routerLink]="['/services']"
      >
        <i class="bi bi-x-circle me-1"></i>
        Cancel
      </button>
      <button class="btn btnprimary" (click)="submitService()">
        <i class="bi bi-save me-1"></i>
        {{ serviceId ? "Update Service" : "Create Service" }}
      </button>
      }
    </div>
  </div>
</div>
